export default __webpack_public_path__ + "static/media/play_again.16bec43b.png";